<template>
  <div>
    <side-bar />
    <!-- comment for GAME 8931  -->
    <!-- <login-tool-tip v-show="!checkMobileDevice() && !appConfig.isAvglDomain" /> -->
    <landing-main />
    <!-- <social /> -->
  </div>
</template>

<script>
import View from '../View';
import { component } from '../../mixins/component';
import SideBar from './sidebar';
// comment for GAME 8931
// import LoginToolTip from './main/LoginToolTip';
import LandingMain from './main';
import { helper } from '../../mixins/helper';
import { LandingAPI } from '../../api/landing';
import { EventBus, SHOW_MODAL_BOOM_CONFIRM, SHOW_MODAL_ONBOARDING_INITIAL } from '../../event-bus';
import { UserAPI } from '../../api/user';
const queryString = require('query-string');

export default {
  components: { SideBar, LandingMain },
  extends: View,
  mixins: [component, LandingAPI, helper, UserAPI],
  data() {
    return {
    };
  },
  created() {
    this.checkUserUpdateEmail();
  },
  methods: {
    checkUserUpdateEmail() {
      const params = queryString.parse(window.location.search);
      if (params.invitee_user) {
        const res = this.checkUserUpdateEmailAPI();
        if (this.isAuth && res.email) {
          const msgNotice = 'AVGL account detected - do you want sign out and register a new account?';
          EventBus.$emit(SHOW_MODAL_BOOM_CONFIRM, msgNotice, this.redirectToCurrentLanding, 'Sign out', 'Cancel', 'Notice', this.cancelConfirm);
        } else if (!this.isAuth && res.email) {
          setTimeout(() => {
            EventBus.$emit(SHOW_MODAL_ONBOARDING_INITIAL, res);
          }, 1000);
        }
      }
    },
    async redirectToCurrentLanding() {
      await this.logoutAPI();
      window.location.reload();
    },
    async cancelConfirm() {
      await this.clearImportUserSessionAPI();
    },
  },
};
</script>
<style lang="scss">
    @import "../../styles/landing/main.scss";
</style>
